module.exports = __webpack_public_path__ + "static/media/midhis1.29438a77.jpg";